<template>
  <div>
    <!-- Botão flutuante -->
    <a class="botao-flutuante" @click.prevent="abrirDemanda" title="Solicitar Demanda">
      <div class="icone-solicitar-material"></div>
    </a>
  </div>
</template>

<script>
export default {
  name: "ChamarDemanda",

  props: {
    propId: {
      type: [String, Number],
      required: true,
    },
    propSigla: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      ambiente: process.env.NODE_ENV,
    };
  },

  computed: {
    urlDemanda() {
      return `https://demandas.thalamus.ind.br/#/solicitar/${this.propSigla}/${this.propId}`;
      // return `https://${this.ambiente == 'development' ? 'demandas-homologacao' : 'demandas'}.thalamus.ind.br/#/solicitar/${this.propSigla}/${this.propId}`;
    },
  },

  methods: {
    abrirDemanda() {
      // Abre em nova janela para compartilhar cookies de sessão
      const largura = 1200;
      const altura = 800;

      // Calcula a posição central da tela
      // Usa screen.availWidth e screen.availHeight para considerar a área disponível
      const screenLeft = window.screenLeft || window.screenX || 0;
      const screenTop = window.screenTop || window.screenY || 0;
      const screenWidth = window.screen.availWidth || window.screen.width;
      const screenHeight = window.screen.availHeight || window.screen.height;

      // Centraliza a janela na tela
      const left = screenLeft + screenWidth / 2 - largura / 2;
      const top = screenTop + screenHeight / 2 - altura / 2;

      // Garante que a janela não saia da tela
      const finalLeft = Math.max(screenLeft, left);
      const finalTop = Math.max(screenTop, top);

      window.open(this.urlDemanda, "SolicitarDemanda", `width=${largura},height=${altura},left=${Math.round(finalLeft)},top=${Math.round(finalTop)},resizable=yes,scrollbars=yes`);
    },
  },
};
</script>

<style scoped>
.botao-flutuante {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(var(--cor-primaria), var(--cor-primaria-forte) 200%);
  color: var(--cor-bg);
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  padding: 0;
  min-width: 56px;
  line-height: 56px;
}

.botao-flutuante:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.15);
}

.botao-flutuante:active {
  transform: scale(1.05);
}

.botao-flutuante:before {
  filter: invert(1);
}

.icone-solicitar-material {
  transform: scale(1.3);
  filter: invert(1);
  display: inline-block;
  position: relative;
  line-height: 48px;
  min-width: 48px;
}

.icone-solicitar-material:before {
  content: "";
  height: 48px;
  width: 48px;
  background: center center/20px auto no-repeat;
  float: left;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='40px' viewBox='0 -960 960 960' width='40px' fill='%23000000'%3E%3Cpath d='M613.33-814H346.67v301.33h266.66V-814Zm200 0H680v301.33h133.33V-814Zm-241 368h-259v260h226q22.11 0 42.63-7.33 20.53-7.34 37.37-22l172-149Q779.33-375 766-381q-13.33-6-28.33-8-17-2.33-32.67 2-15.67 4.33-29.51 15.18L568.67-286H413.33v-66.67H546L591.33-390q8.34-6.33 10.84-14.67 2.5-8.33.5-17-2-10-10.17-17.16-8.17-7.17-20.17-7.17Zm-325.66 0h-100v300h100v-300Zm33.33 0v-367.33q0-27 19.83-46.84Q319.67-880 346.67-880h466.66q27 0 46.84 19.83Q880-840.33 880-813.33v300.66q0 27-19.83 46.84Q840.33-446 813.33-446H280ZM246.67-79.33h-100q-27 0-46.84-19.84Q80-119 80-146v-300q0-27 19.83-46.83 19.84-19.84 46.84-19.84h425.66q82.34 0 157.34 29t126.33 92l28.33 35-221 192q-25.66 22.34-58 33.84-32.33 11.5-66 11.5H307q-8.33 17.33-24.47 28.66-16.14 11.34-35.86 11.34Z'/%3E%3C/svg%3E");
}

@media screen and (max-width: 970px) {
  .botao-flutuante {
    bottom: 16px;
    right: 16px;
    width: 48px;
    height: 48px;
  }
}
</style>
